const userAgent = window.navigator.userAgent;

export const isIE = userAgent.indexOf("MSIE") > 0 || userAgent.indexOf("Trident/") > 0;

export enum ContentType {
  EXCEL = "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
}
